import styled from "styled-components";

export const ConsolePageModalContentContainer = styled.div`
  padding: 24px;

  border-bottom: 1px solid
    ${({ theme }) => theme.console.comments.cardsBorderColor};

  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }

  &::-webkit-scrollbar-track {
    width: 4px;
    display: block;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    display: block;
  }
`;
